import "./DaCheckEmail.css";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import DaPageWrapper from "../DaPageWrapper/DaPageWrapper";
import { Translate } from "../../helpers/TranslatedComponent";
import { T_KEYS } from "../../locales/translationKeys";
import { translateStatic } from "../../hooks/useT/useT";

const DaCheckEmail = () => {
  return (
    <DaPageWrapper
      wrapperClass="da-msg-card da-page-wrapper"
      iconType="mail"
      title={<Translate tKey={T_KEYS.DA.CHECK_EMAIL.TITLE} />}
      subtitle={
        <>
          {translateStatic(T_KEYS.DA.CHECK_EMAIL.DESCRIPTION.PREFIX)}
          <br />
          name@email.com
        </>
      }
    >
      <Button variant="contained" fullWidth className="da-button da-check-email-button">
        {translateStatic(T_KEYS.DA.LINK_EXPIRED.BUTTON.OPENMAIL)}
      </Button>

      <Typography variant="caption" color="text.secondary" className="da-msg-footer">
        {translateStatic(T_KEYS.DA.LINK_EXPIRED.FOOTER)}
      </Typography>
    </DaPageWrapper>
  );
};

export { DaCheckEmail };
